import React, { useState } from "react";
import { Table } from "antd";
import { categoryTypes } from "../../../../../types";
import { ColumnType } from "antd/es/table";

type DragTableProps = {
  data: typeof categoryTypes.category[];
  onDragEnd: (newData: typeof categoryTypes.category[]) => void;
  columns: ColumnType<typeof categoryTypes.category>[];
  loading: boolean;
};

const DragTable: React.FC<DragTableProps> = ({ data, onDragEnd, columns, loading }) => {
  const [draggedRow, setDraggedRow] = useState<typeof categoryTypes.category | null>(null);

  const handleDragStart = (e: React.DragEvent<HTMLTableRowElement>, record: typeof categoryTypes.category) => {
    setDraggedRow(record);
    e.dataTransfer.setData("text", JSON.stringify(record));
  };

  const handleDragOver = (e: React.DragEvent<HTMLTableRowElement>) => {
    e.preventDefault();
  };

  const handleDrop = (e: React.DragEvent<HTMLTableRowElement>, targetRow: typeof categoryTypes.category) => {
    e.preventDefault();
    if (draggedRow) {
      const newData = [...data];
      const draggedIndex = newData.findIndex((item) => item.id === draggedRow.id);
      const targetIndex = newData.findIndex((item) => item.id === targetRow.id);

      newData[draggedIndex] = targetRow;
      newData[targetIndex] = draggedRow;

      onDragEnd(newData);
    }
  };

  const onRow = (record: typeof categoryTypes.category) => ({
    draggable: true,
    onDragStart: (e: React.DragEvent<HTMLTableRowElement>) => handleDragStart(e, record),
    onDragOver: (e: React.DragEvent<HTMLTableRowElement>) => handleDragOver(e),
    onDrop: (e: React.DragEvent<HTMLTableRowElement>) => handleDrop(e, record),
  });

  return <Table
    style={{ marginTop:10 }}
    rowKey="id"
    columns={columns}
    dataSource={data}
    loading={loading}
    onRow={onRow}
    pagination={false}
  />;
};

export default DragTable;
